module.exports = __webpack_public_path__ + "lato-hairline-ada4458b361d5e72bcbd19da105afdc5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-hairline/lato-hairline.woff2
// module id = 1034
// module chunks = 0